/**
 * Swiper
 * https://swiperjs.com/
 */

import { hellopanda_func as $ } from '../../../assets/script/func.js';
import { Swiper as SPSWIPER } from 'swiper';
import { 
  Navigation, Pagination, Scrollbar, Autoplay, EffectFade, EffectCube, EffectCoverflow, EffectFlip, 
  EffectCreative, EffectCards, Mousewheel, Grid, Thumbs, FreeMode, Controller, HashNavigation 
} from 'swiper/modules';

import 'swiper/css/bundle';

const HELLOPANDA_SWIPER = {
  init: function() {

    const _ = this;

    if (!SPSWIPER) {
      console.warn("swiper module not found, the swiper effect is disabled.");
      return;
    }

    document.addEventListener('DOMContentLoaded', function() {

      _.setExternalButtons();
  
      const allSwipers = [];
      const swiperArray = document.querySelectorAll('.wp-block-hellopanda-swiper-block');
      swiperArray.forEach((element, index) => {

        const container = element.querySelector('.swiper');
        const options = $.removeEmptyObject({
          ..._.getBase(element),
          ..._.getNavigation(element),
          ..._.getPagination(element),
          ..._.getScrollbar(element),
          ..._.getAutoplay(element),
          ..._.getFadeEffect(element),
          ..._.getCubeEffect(element),
          ..._.getCoverflowEffect(element),
          ..._.getFlipEffect(element),
          ..._.getCardsEffect(element),
          ..._.getGrid(element),
        });
        const slider = new SPSWIPER(container, {
          modules: [
            Navigation, Pagination, Scrollbar, Autoplay, EffectFade, EffectCube, EffectCoverflow, EffectFlip, 
            EffectCreative, EffectCards, Mousewheel, Grid, Thumbs, FreeMode, Controller, HashNavigation],
          init: false,
          ...options
        });

        /**
         * 생성완료
         */
        slider.on('init', function () {

          // 컨테이너 종료 표시
          setTimeout(() => {
            element.classList.add('wp-block-hellopanda-swiper-initialized');
          }, 1);

          /**
           * GSAP 예외처리
           */
          // const gsap = element.closest('.wp-block-hellopanda-gsap-block[data-gsap-pin="true"]');
          // if (gsap) {
          //   const activeSlide = slider.slides[slider.activeIndex];
          //   if (activeSlide) {
          //     activeSlide.classList.remove('swiper-slide-active');
          //     window.addEventListener("load", () => {
          //       gsap.classList.add('wp-block-hellopanda-swiper-loaded')
          //       activeSlide.classList.add('swiper-slide-active');
          //     });
          //   }
          // }

          allSwipers.push({
            [options.swiperID]: {
              swiper: slider,
              used: false
            }
          });
          if (index === swiperArray.length - 1) {

            // 슬라이더 연결
            swiperArray.forEach(el => {
              const currentID = el.id;
              const targetID = el.dataset.target;
              const currentIndex = _.getSwiperIndex(currentID, allSwipers);
              const targetIndex = _.getSwiperIndex(targetID, allSwipers);
              if (currentIndex >= 0 && targetIndex >= 0) {
                _.connectSwipers(allSwipers[currentIndex][currentID].swiper, allSwipers[targetIndex][targetID].swiper);
              }
            });

            // 배열 비우기
            allSwipers.splice(0, allSwipers.length);
          }

          // 슬라이더에 연결된 버튼 컨트롤 및 지정
          _.externalButtons(element.id, slider);
          _.externalButtonsStatus(element.id, slider);

        });

        /**
         * 슬라이더 변경 체크
         */
        slider.on('slideChange', function () {

          // 슬라이더 초기 상태 지정
          _.externalButtonsStatus(element.id, slider);

        });

        /**
         * FADE + REWIND 옵션일 때 대상 외 슬라이드 숨기기
         */
        slider.on('slideChangeTransitionStart', function () {
          if (!slider.params?.rewind || slider.params?.effect != 'fade') return;

          // 숨기기
          const totalSlides = slider.slides.length;
          const { previousIndex, activeIndex } = slider;
          const isRewindBack = previousIndex === totalSlides - 1 && activeIndex === 0;
          const isRewindForward = previousIndex === 0 && activeIndex === totalSlides - 1;
          if (isRewindBack || isRewindForward) {
            slider.slides.forEach((slide, index) => {
              if (index !== previousIndex && index !== activeIndex) {
                slide.classList.add('swiper-is-rewind-hide');
                slide.style.visibility = 'hidden';
              }
            });
          }
        });

        /**
         * FADE + REWIND 옵션일 때 숨긴 슬라이드 복구
         */
        slider.on('slideChangeTransitionEnd', function () {
          if (!slider.params?.rewind || slider.params?.effect != 'fade') return;

          // 복구
          slider.slides.forEach((slide) => {
            if (slide.classList.contains('swiper-is-rewind-hide')) {
              slide.style.visibility = '';
              slide.classList.remove('swiper-is-rewind-hide');
            }
          });
        });

        // 실행
        slider.init();

      });
     
    });
  },

  /**
   * 외부 버튼 선정의
   */
  setExternalButtons: function() {

    // 만약 부모가 없는 외부 버튼이 있다면
    // 자신이 속한 슬라이더를 기준한다.
    const buttons = document.querySelectorAll(`.wp-block-hellopanda-swiper-buttons-block[data-swiper=""]`);
    buttons.forEach(button => {
      
      const slider = button.closest('.wp-block-hellopanda-swiper-block');
      if (slider) {
        button.setAttribute('data-swiper', slider.id);
      }

    });

  },

  /**
   * 외부 버튼
   */
  externalButtons: function(id, slider) {

    const buttons = document.querySelectorAll(`.wp-block-hellopanda-swiper-buttons-block[data-swiper="${id}"]`);
    buttons.forEach(button => {
      const index = button.dataset.index || 0;
      const direction = button.dataset.direction || '';
      button.addEventListener('click', function() {
        if (direction && slider.animating) {
          return;
        }
        if (direction === 'prev') {
          slider.slidePrev();
        } else if (direction === 'next') {
          slider.slideNext();
        } else {
          slider.slideTo(index);
        }
      });
    });

  },

  /**
   * 버튼 초기 상태 정의
   */
  externalButtonsStatus: function(id, slider) {

    const buttons = document.querySelectorAll(`.wp-block-hellopanda-swiper-buttons-block[data-swiper="${id}"]`);
    buttons.forEach(button => {
      const index = parseInt(button.dataset.index, 10);
      const direction = button.dataset.direction;
      const currentIndex = slider.realIndex;

      let isActive = false;

      if (direction && (slider.params?.loop || slider.params?.rewind)) {
        isActive = true;
      } else if (direction === 'prev') {
        isActive = currentIndex > 0;
      } else if (direction === 'next') {
        isActive = !slider.isEnd;
      } else if (!isNaN(index)) {
        isActive = index === currentIndex;
      }

      button.setAttribute('data-onoff', isActive ? 'on' : 'off');
    });

  },

  /**
   * 기본정보
   */
  getBase: function(element) {

    const _ = this;

    const base = {
      speed: 500,
      slidesPerView: 1.0001
    };
    const swiperID = element.id || 'swiper-' + $.randomString(10) ;
    const direction = element.dataset.parameterDirection || 'horizontal' ;
    const allowTouchMove = element.dataset.parameterAllowTouchMove || null ;
    const autoHeight = element.dataset.parameterAutoHeight || null ;
    const centerInsufficientSlides = element.dataset.parameterCenterInsufficientSlides || null ;
    const centeredSlides = element.dataset.parameterCenteredSlides || null ;
    const centeredSlidesBounds = element.dataset.parameterCenteredSlidesBounds || null ;
    const edgeSwipeDetection = element.dataset.parameterEdgeSwipeDetection || null ;
    const edgeSwipeThreshold = element.dataset.parameterEdgeSwipeThreshold || null ;
    const effect = element.dataset.parameterEffect || null ;
    const grabCursor = element.dataset.parameterGrabCursor || null ;
    const initialSlide = element.dataset.parameterInitialSlide || null ;
    const randomSlide = element.dataset.parameterRandomSlide || null ;
    const loop = element.dataset.parameterLoop || null ;
    const loopAddBlankSlides = element.dataset.parameterLoopAddBlankSlides || null ;
    const loopAdditionalSlides = element.dataset.parameterLoopAdditionalSlides || null ;
    const loopPreventsSliding = element.dataset.parameterLoopPreventsSliding || null ;
    const mousewheel = element.dataset.parameterMousewheel || null ;
    const nested = element.dataset.parameterNested || null ;
    const slidesPerView = element.dataset.parameterSlidesPerView || null ;
    const slidesPerGroup = element.dataset.parameterSlidesPerGroup || null ;
    const spaceBetween = element.dataset.parameterSpaceBetween || null ;
    const speed = element.dataset.parameterSpeed || null ;
    const threshold = element.dataset.parameterThreshold || null ;
    const breakpoints = element.dataset.parameterBreakpoints || null ;
    const breakpointsBase = element.dataset.parameterBreakpointsBase || null ;
    const slideToClickedSlide = element.dataset.parameterSlideToClickedSlide || null ;
    const freeMode = element.dataset.parameterFreeMode || null ;
    const preventInteractionOnTransition = element.dataset.parameterPreventInteractionOnTransition || null ;
    const rewind = element.dataset.parameterRewind || null ;
    const hashNavigation = element.dataset.parameterHashNavigation || null ;
    const hashNavigationReplace = element.dataset.parameterHashNavigationReplace || null ;

    if (swiperID) {
      base.swiperID = swiperID;
    }
    if (direction) {
      base.direction = direction;
    }
    if (allowTouchMove != null) {
      base.allowTouchMove = _.isBoolean(allowTouchMove);
    }
    if (autoHeight) {
      base.autoHeight = _.isBoolean(autoHeight);
      base.slidesPerView = 1;
    }
    if (centerInsufficientSlides) {
      base.centerInsufficientSlides = _.isBoolean(centerInsufficientSlides);
    }
    if (centeredSlides) {
      base.centeredSlides = _.isBoolean(centeredSlides);
    }
    if (centeredSlidesBounds) {
      base.centeredSlidesBounds = _.isBoolean(centeredSlidesBounds);
    }
    if (edgeSwipeDetection) {
      base.edgeSwipeDetection = _.isBoolean(edgeSwipeDetection);
    }
    if (edgeSwipeThreshold) {
      base.edgeSwipeThreshold = _.isNumber(edgeSwipeThreshold);
    }
    if (effect) {
      base.effect = effect;
    }
    if (grabCursor) {
      base.grabCursor = _.isBoolean(grabCursor);
    }
    if (initialSlide) {
      base.initialSlide = _.isNumber(initialSlide);
    } else if (randomSlide) {
      const slideCount = element.querySelectorAll('.wp-block-hellopanda-swiper-slide-block').length;
      base.initialSlide = $.randomNumber(slideCount) - 1;
    }
    if (loop) {
      base.loop = _.isBoolean(loop);
    }
    if (loopAddBlankSlides) {
      base.loopAddBlankSlides = _.isBoolean(loopAddBlankSlides);
    }
    if (loopAdditionalSlides) {
      base.loopAdditionalSlides = _.isNumber(loopAdditionalSlides);
    }
    if (loopPreventsSliding) {
      base.loopPreventsSliding = _.isBoolean(loopPreventsSliding);
    }
    if (mousewheel) {
      base.mousewheel = _.isBoolean(mousewheel);
    }
    if (nested) {
      base.nested = _.isBoolean(nested);
    }
    if (slidesPerView) {
      if (base.autoHeight) {
        base.slidesPerView = _.isNumber(slidesPerView);
      } else {
        base.slidesPerView = _.isNumber(slidesPerView) - 0.0001;
      }
    }
    if (slidesPerGroup) {
      base.slidesPerGroup = _.isNumber(slidesPerGroup);
    }
    if (spaceBetween) {
      base.spaceBetween = spaceBetween; // % 까진 지원하는거 같은디 ...
    }
    if (speed) {
      base.speed = _.isNumber(speed);
    }
    if (threshold) {
      base.threshold = _.isNumber(threshold);
    }
    if (breakpoints) {
      const decodedBreakpoints = decodeURIComponent(breakpoints);
      base.breakpoints = JSON.parse(decodedBreakpoints);
      base.breakpoints = _.updateBreakpoints(base.breakpoints, base.slidesPerView, base.slidesPerGroup, base.spaceBetween);
    }
    if (breakpointsBase) {
      base.breakpointsBase = breakpointsBase;
    }
    if (slideToClickedSlide) {
      base.slideToClickedSlide = _.isBoolean(slideToClickedSlide);
    }
    if (freeMode) {
      base.freeMode = _.isBoolean(freeMode);
    }
    if (preventInteractionOnTransition) {
      base.preventInteractionOnTransition = _.isBoolean(preventInteractionOnTransition);
    }
    if (rewind) {
      base.rewind = _.isBoolean(rewind);
    }
    if (hashNavigation) {
      base.hashNavigation = {}
      base.hashNavigation.watchState = true;
      if (hashNavigationReplace) {
        base.hashNavigation.replaceState = true;
      }
    }

    return base;

  },

  /**
   * 네비게이션
   */
  getNavigation: function(element) {

    const _ = this;

    const id = element.id;
    const navigation = {
      prevEl: `#${id} .swiper-button-prev`,
      nextEl: `#${id} .swiper-button-next`,
    }

    return {
      navigation
    }

  },

  /**
   * 페이지
   */
  getPagination: function(element) {

    const _ = this;

    const id = element.id;
    const pagination = {
      el: `#${id} .swiper-pagination`
    }
    const block = element.querySelector('.wp-block-hellopanda-swiper-pagination-block');
    const type = block ? block.dataset.type : null ;
    const clickable = block ? block.dataset.clickable : null ;
    const dynamicBullets = block ? block.dataset.dynamicBullets : null ;
    const fractionWord = block ? block.dataset.fractionWord : null ;
    if (type) {
      pagination.type = type;
    }
    if (clickable) {
      pagination.clickable = _.isBoolean(clickable);
    }
    if (dynamicBullets) {
      pagination.dynamicBullets = _.isBoolean(dynamicBullets);
    }
    if (fractionWord) {
      pagination.renderFraction = function (currentClass, totalClass) {
        return '<span class="' + currentClass + '"></span>' + fractionWord + '<span class="' + totalClass + '"></span>';
      }
    }

    return {
      pagination
    }

  },

  /**
   * 스크롤바
   */
  getScrollbar: function(element) {

    const _ = this;

    const id = element.id;
    const scrollbar = {
      el: `#${id} .swiper-scrollbar`,
      hide: true // 설정 안하면 동작 안함 ( 버그로 예상됨 )
    }
    const drag = element.querySelector('.swiper-scrollbar-drag');
    const hide = drag ? drag.dataset.hide : null ;
    const dragSize = drag ? drag.dataset.dragSize : null ;
    const draggable = drag ? drag.dataset.draggable : null ;

    if (hide) {
      scrollbar.hide = _.isBoolean(hide);
    }
    if (dragSize) {
      scrollbar.dragSize = dragSize;
    }
    if (draggable) {
      scrollbar.draggable = _.isBoolean(draggable);
    }

    return {
      scrollbar
    }

  },

  /**
   * Autoplay
   */
  getAutoplay: function(element) {

    const _ = this;

    let autoplay = {
      waitForTransition: true, // 설정 안하면 동작 안함 ( 버그로 예상됨 )
      disableOnInteraction: true // 설정 안하면 동작 안함 ( 버그로 예상됨 )
    };
    const visible = element.dataset.autoplay || null ;
    const delay = element.dataset.autoplayDelay || null ;
    const disableOnInteraction = element.dataset.autoplayDisableOnInteraction || null;
    const pauseOnMouseEnter = element.dataset.autoplayPauseOnMouseEnter || null ;
    const stopOnLastSlide = element.dataset.autoplayStopOnLastSlide || null ;
    const waitForTransition = element.dataset.autoplayWaitForTransition || null ;
    if (delay) {
      autoplay = {
        ...autoplay,
        delay: _.isNumber(delay)
      }
    }
    if (disableOnInteraction) {
      autoplay = {
        ...autoplay,
        disableOnInteraction: _.isBoolean(disableOnInteraction)
      }
    }
    if (pauseOnMouseEnter) {
      autoplay = {
        ...autoplay,
        pauseOnMouseEnter: _.isBoolean(pauseOnMouseEnter)
      }
    }
    if (stopOnLastSlide) {
      autoplay = {
        ...autoplay,
        stopOnLastSlide: _.isBoolean(stopOnLastSlide)
      }
    }
    if (waitForTransition) {
      autoplay = {
        ...autoplay,
        waitForTransition: _.isBoolean(waitForTransition)
      }
    }

    return visible ? {
      autoplay
    } : null ;

  },

  /**
   * Fade Effect
   */
  getFadeEffect: function(element) {

    const _ = this;

    let fadeEffect = {};
    const crossFade = element.dataset.fadeEffectCrossFade || null ;
    if (crossFade) {
      fadeEffect.crossFade = _.isBoolean(crossFade);
    }

    return {
      fadeEffect
    }

  },

  /**
   * Cube Effect
   */
  getCubeEffect: function(element) {

    const _ = this;

    let cubeEffect = {};
    const shadow = element.dataset.cubeEffectShadow || null ;
    const shadowOffset = element.dataset.cubeEffectShadowOffset || null ;
    const shadowScale = element.dataset.cubeEffectShadowScale || null ;
    const slideShadows = element.dataset.cubeEffectSlideShadows || null ;
    if (shadow) {
      cubeEffect.shadow = _.isBoolean(shadow);
    }
    if (shadowOffset) {
      cubeEffect.shadowOffset = _.isNumber(shadowOffset);
    }
    if (shadowScale) {
      cubeEffect.shadowScale = _.isNumber(shadowScale);
    }
    if (slideShadows) {
      cubeEffect.slideShadows = _.isBoolean(slideShadows);
    }

    return {
      cubeEffect
    }

  },

  /**
   * Coverflow Effect
   */
  getCoverflowEffect: function(element) {

    const _ = this;

    let coverflowEffect = {};
    const depth = element.dataset.coverflowEffectDepth || null ;
    const modifier = element.dataset.coverflowEffectModifier || null ;
    const rotate = element.dataset.coverflowEffectRotate || null ;
    const scale = element.dataset.coverflowEffectScale || null ;
    const slideShadows = element.dataset.coverflowEffectSlideShadows || null ;
    const stretch = element.dataset.coverflowEffectStretch || null ;
    if (depth) {
      coverflowEffect.depth = _.isNumber(depth);
    }
    if (modifier) {
      coverflowEffect.modifier = _.isNumber(modifier);
    }
    if (rotate) {
      coverflowEffect.rotate = _.isNumber(rotate);
    }
    if (scale) {
      coverflowEffect.scale = _.isNumber(scale);
    }
    if (slideShadows) {
      coverflowEffect.slideShadows = _.isBoolean(slideShadows);
    }
    if (stretch) {
      coverflowEffect.stretch = _.isNumber(stretch);
    }

    return {
      coverflowEffect
    }

  },

  /**
   * Flip Effect
   */
  getFlipEffect: function(element) {

    const _ = this;

    let flipEffect = {};
    const limitRotation = element.dataset.flipEffectLimitRotation || null ;
    const slideShadows = element.dataset.flipEffectSlideShadows || null ;
    if (limitRotation) {
      flipEffect.limitRotation = _.isBoolean(limitRotation);
    }
    if (slideShadows) {
      flipEffect.slideShadows = _.isBoolean(slideShadows);
    }

    return {
      flipEffect
    }

  },

  /**
   * Cards Effect
   */
  getCardsEffect: function(element) {

    const _ = this;

    let cardsEffect = {};
    const perSlideOffset = element.dataset.cardsEffectPerSlideOffset || null ;
    const perSlideRotate = element.dataset.cardsEffectPerSlideRotate || null ;
    const rotate = element.dataset.cardsEffectRotate || null ;
    const slideShadows = element.dataset.cardsEffectSlideShadows || null ;
    if (perSlideOffset) {
      cardsEffect.perSlideOffset = _.isNumber(perSlideOffset);
    }
    if (perSlideRotate) {
      cardsEffect.perSlideRotate = _.isNumber(perSlideRotate);
    }
    if (rotate) {
      cardsEffect.rotate = _.isBoolean(rotate);
    }
    if (slideShadows) {
      cardsEffect.slideShadows = _.isBoolean(slideShadows);
    }

    return {
      cardsEffect
    }

  },

  /**
   * Grid
   */
  getGrid: function(element) {

    const _ = this;

    let grid = {};
    const rows = element.dataset.gridRows || null ;
    const fill = element.dataset.gridFill || null ;
    if (rows) {
      grid.rows = _.isNumber(rows);
    }
    if (rows && fill) {
      grid.fill = fill;
    }

    return {
      grid
    }

  },

  // 브레이크 포인트 업데이트
  updateBreakpoints: function(breakpoints, slidesPerView, slidesPerGroup, spaceBetween) {

    const _ = this;

    // 각 브레이크포인트를 순회
    Object.keys(breakpoints).forEach((key) => {

      // console.log( breakpoints[key], key )
      // console.log( breakpoints[key].slidesPerView, 'breakpoints[key].slidesPerView')

      // 슬라이드 수
      if (breakpoints[key].slidesPerView === undefined) {
        breakpoints[key].slidesPerView = _.isNumber(slidesPerView) || 1;
      }

      // 슬라이드 그룹 수
      if (breakpoints[key].slidesPerGroup === undefined) {
        breakpoints[key].slidesPerGroup = _.isNumber(slidesPerGroup) || 1;
      }

      // 슬라이드 간격
      if (breakpoints[key].spaceBetween === undefined) {
        breakpoints[key].spaceBetween = spaceBetween || '0px';
      }

      // 네비게이션
      if (breakpoints[key].navigation === undefined) {
        breakpoints[key].navigation = { enabled: true };
      } else {
        breakpoints[key].navigation = { enabled: breakpoints[key].navigation };
      }

      // 페이지
      if (breakpoints[key].pagination === undefined) {
        breakpoints[key].pagination = { enabled: true };
      } else {
        breakpoints[key].pagination = { enabled: breakpoints[key].pagination };
      }

      // 스크롤바
      if (breakpoints[key].scrollbar === undefined) {
        breakpoints[key].scrollbar = { enabled: true };
      } else {
        breakpoints[key].scrollbar = { enabled: breakpoints[key].scrollbar };
      }

    });
  
    return breakpoints;

  },

  // 불리언 값 반환
  isBoolean: function(str) {
    if (str === 'true') {
      return true;
    } else {
      return false;
    }
  },

  // 숫자 값 반환
  isNumber: function(str) {
    const num = Number(str);
    return !isNaN(num) ? num : str ;
  },

  /**
   * 슬라이더 연결
   */
  getSwiperIndex(id, allSwipers) {
    return allSwipers.findIndex(swiperObj => {
      const swiperID = Object.keys(swiperObj)[0]; // 객체의 키(즉, swiperID)를 가져옴
      return swiperID === id; // ID가 일치하면 해당 인덱스를 반환
    });
  },
  connectSwipers(source, target) {

    source.params.slideActiveClass = 'ignore--swiper-slide-active'
    source.update()

    target.params.thumbs.slideThumbActiveClass = 'swiper-slide-active';
    target.params.thumbs.swiper = source
    target.update()
    target.thumbs.init()
    target.thumbs.update()

  }

};
HELLOPANDA_SWIPER.init();